(function(algolia) {
  'use strict';
  algolia.translations = {
    search: '検索結果',
    noCollectionFound: 'コレクションは見つかりませんでした。',
    allProducts: '全て見る',
    matching: '一致',
    sortBy: '絞り込み',
    relevance: '関連',
    outOf: 'out of',
    resultsFound: '件見つかりました',
    oneResultFound: '1 件見つかりました',
    noResultFound: '該当するものはありませんでした。',
    addToCart: 'カートに入れる',
    searchForProduct: '商品を検索する',
    selectedFilter: '選択したフィルター',
    clearAll: 'クリア',
    noPageFound: 'ページは見つかりませんでした。',
    outOfStock: '売り切れ',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'No result for query ' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' out of'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
